import type { FunctionComponent, PropsWithChildren } from 'react';
import { ThemeProvider } from '@george-labs.com/design-system';
import type { ThemeProviderProps } from '@george-labs.com/design-system/types/containers/ThemeProvider';

import { GdsLanguageProvider } from '@shared/gds-translations';
import { isFeatureEnabled } from '@luna/gatekeeper';
import './GDSProvider.scss';

type Props = { useDarkMode?: boolean };

export const GDSProvider: FunctionComponent<PropsWithChildren<ThemeProviderProps & Props>> = (
    props,
) => (
    <GdsLanguageProvider>
        <ThemeProvider
            {...props}
            useDarkMode={props.useDarkMode}
            useBs5Grid={isFeatureEnabled((config) => config.bsExtendedGrid)}
            useFluidGrid={isFeatureEnabled((config) => config.bsExtendedGrid)}
            useExtendedGrid={isFeatureEnabled((config) => config.bsExtendedGrid)}
        >
            {props.children}
        </ThemeProvider>
    </GdsLanguageProvider>
);
